import auth from "./Auth";
import dashboard from "./Dashboard";
import userRequest from "./UserRequest";

/**
 * Combine and export access control modules related to various features such as authentication, dashboard, and user request.
 * @constant {Object} AccessControl
 */
const InstructorAccessControl = {
  ...auth,
  ...dashboard,
  ...userRequest,
};

export default InstructorAccessControl;
